import { Theme } from '../';
import { palette } from './palette';
import { scales } from './scales';
import {images}  from './images';
import { fontStyles, fontStylesObj } from './typography';
import { spacing, spacingPx } from "../../spacing";
import { utilities } from "../../utilities";

export const wpaTheme: Theme = {
  palette,
  typography: fontStyles,
  typographyObj: fontStylesObj,
  spacing,
  spacingPx,
  utilities,
  scales,
  images
};

// console.log(wpaTheme)